module.exports = "img/flags/MV.c8960c1.png";